(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["det-tilbyder-vi"] && !Shopify.designMode) return;
  try {
    
  (function(){
    // Elementer er synlige som standard i CSS'en. Kun hvis dette script rent faktisk
    // kører, og browseren understøtter IntersectionObserver, går de i "pending" (skjult)
    // tilstand og animeres ind ved scroll. Sådan kan indholdet aldrig blive usynligt,
    // hvis scriptet af en grund ikke skulle køre (fx i visse forhåndsvisninger).
    var els = document.querySelectorAll('.dtv-reveal');
    if (!els.length || !('IntersectionObserver' in window)) return;
    els.forEach(function(el){ el.classList.add('dtv-pending'); });
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting){ e.target.classList.add('dtv-is-visible'); io.unobserve(e.target); }
      });
    }, {threshold:.15});
    els.forEach(function(el){ io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
